import "./App.css";
import Valorame from "./pages/Valorame";
import GlobalHeader from "./components/GlobalHeader";
import GlobalFooter from "./components/GlobalFooter";

function App() {
	return (
		<div className="grid-container">
			<GlobalHeader />
			<main className="main-content">
				<Valorame />
			</main>
			<GlobalFooter />
		</div>
	);
}

export default App;
